import { render, staticRenderFns } from "./receiptsTrashed.vue?vue&type=template&id=74a2a559&scoped=true&"
import script from "./receiptsTrashed.vue?vue&type=script&lang=js&"
export * from "./receiptsTrashed.vue?vue&type=script&lang=js&"
import style0 from "./receiptsTrashed.vue?vue&type=style&index=0&lang=css&"
import style1 from "./receiptsTrashed.vue?vue&type=style&index=1&id=74a2a559&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a2a559",
  null
  
)

export default component.exports